<template>
   <section>金融城</section>
</template>

<script>
export default {
   data () {
      return {

      };
   },

   components: {},

   mounted() {},

   methods: {}
}
</script>
<style lang='scss' scoped>

</style>